import React from 'react';
import './App.css';
import JSONCompare from './components/JSONCompare';

function App() {
  return (
    <div className="App">
      <header className="bg-gray-800 text-white p-4 mb-6">
        <h1 className="text-2xl font-bold">JSON Comparison Tool</h1>
        <p className="text-sm">Compare large JSON payloads with key-order insensitivity</p>
      </header>
      <main className="container mx-auto px-4 pb-12">
        <JSONCompare />
      </main>
    </div>
  );
}

export default App;